/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
export const TOO_LONG = "Too long.";
export const TOO_SHORT = "Please provide the required number of characters.";
export const SELECTION_REQUIRED = "Selection required.";
export const INVALID_LINK = "This URL is not allowed.";
export const INPUT_REQUIRED = "Input required.";
export const PROVIDE_HTTPS = "Please provide full URL containing http:// or https://";
export const PROVIDE_HTTPS_SOCIAL_MEDIA =
  "Please provide full URL to your account containing http:// or https://";
export const VIDEO_AND_WRITTEN_CANNOT_BE_EMPTY =
  "Video link and written response both cannot be empty.";
export const PHONE_REG_EX = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
export const INVALID = "Invalid.";
export const LINK_REQUIRED = "One video link is required";
export const WRITTEN_REQUIRED_VIDEO_URL_EXISTS =
  "Written response is required because video url exists";
export const CANNOT_HAVE_VIDEO_AND_WRITTEN = "Cannot have video link and written response";
export const INVALID_QUANTITY_GREATER_THAN_TOTAL =
  "Invalid quantity, greater than total order quantity.";
export const INVALID_QUANTITY_LESS_THAN_ZERO = "Quantity cannot be smaller than 0.";
export const INVALID_ORDER =
  "We limit orders to less than or equal to 100 lunches/event. You will not be able to proceed if your order is larger than 100 lunches. Please return to the previous page and edit your number of event attendees to less than 100. If you still need to request a larger order size, you can place a smaller order and tell us that you need an exception in the order details box.";
export const CHARACTERS_EXCEEDED = "No characters remaining";
export const CHARACTERS_REMAINING = "characters remaining";
export const INVALID_PHONE_NUMBER =
  "Your phone number is not valid for the phone Country or Region: ";
export const INACTIVE_USER_WARNING_MESSAGE =
  "User is not an active student ambassador, no edit allowed!";
export const ADDRESS_ENGLISH_REG_EX = /^[a-zA-Z0-9,\s\.\-\#]+$/;
export const INVALID_ADDRESS_ENGLISH_CHARS = "Invalid character.";
export const EMAIL_NOT_ALLOWED = "You cannot use this email address.";
export const INVALID_EMAIL_REG_EX = /^[a-zA-Z0-9._%-]+@(?!studentambassadors\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
export const GUID_REG_EX = /^[0-9a-fA-F]{8}-?([0-9a-fA-F]{4}-?){3}[0-9a-fA-F ]{12}$/;
